<template>
  <div class="additional-left-menu uppercase px-1 pt-3">
    <CohortsLeftMenuLink :link="{ name: 'cohorts' }" icon="mdi-magnify" text="Find & Create Cohorts" :forceActive="selectDefault" />
    <CohortsLeftMenuLink :link="{ name: 'cohortsPinned' }" icon="mdi-pin-outline" text="Pinned Cohorts" :forceActive="selectDefault && 'disable'" v-if="getFlag('cohorts-show-pinned')" />
    <CohortsLeftMenuLink :link="{ name: 'cohortsMyCohorts' }" icon="mdi-shield-account-outline" text="My Cohorts" :forceActive="selectDefault && 'disable'" />
    <CohortsLeftMenuLink
      :link="{ name: 'cohortsForVerifications' }"
      icon="mdi-shield-alert-outline"
      text="Pending Verifications"
      :forceActive="selectDefault && 'disable'"
      @click="loadCountOfCohortsForVerifications"
      v-if="getFlag('is-user-able-to-clinically-verify-cohorts')"
    >
      <span class="custom-badge ml-2" v-if="countOfCohortsForVerifications">{{ countOfCohortsForVerifications }}</span>
    </CohortsLeftMenuLink>

    <div class="px-2 py-3">
      <router-link class="button" to="/Analytics/Cohort/Create">New Cohort</router-link>
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import { errorDebug } from '../../libraries/common';
import CohortsLeftMenuLink from './CohortsLeftMenuLink.vue'
export default {
  components: { CohortsLeftMenuLink },
  props: ['value', 'selectDefault'],
  data() {
    return {
      countOfCohortsForVerifications: 0,
    }
  },
  methods: {
    loadCountOfCohortsForVerifications() {
      if (this.getFlag('is-user-able-to-clinically-verify-cohorts'))
        axios.get(`/Analytics/Cohorts/CountOfCohortsForVerifications`)
          .then(({ data }) => this.countOfCohortsForVerifications = data)
          .catch(errorDebug);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortsLeftMenu'] = this;
    this.loadCountOfCohortsForVerifications();
  },
}
</script>

<style lang="scss" scoped>
.additional-left-menu {
  background-color: #e6f6f8;
  min-height: 100%;

  .icon {
    font-size: 16px;

    &.pin {
      transform: rotate(45deg);
    }
  }

  .button {
    display: block;
    padding: 8px 10px;
    border-radius: 7px;
    background-color: #666adf;
    color: white;
    font-size: 14px;
    text-align: center;
  }
}

.custom-badge {
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0px 7px;
}
</style>